import { newIncome } from "../../createIncome";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Fragment, useState } from "react";
import { Menu, MenuButton, MenuItem, Transition } from "@headlessui/react";
import { useInfo } from "../../hooks/useData";
import { Income, IncomeType, Person } from "src/types";

interface AddIncomeProps {
  addIncome: any;
  incomes: Income[];
}
const AddItem = ({
  type,
  title,
  person,
  addIncome,
}: {
  type: string;
  title: string;
  person: Person;
  addIncome: (income: Income) => void;
}) => {
  const { data } = useInfo();
  const people = data.people;
  const [time, setTime] = useState(0);
  if (type == "social-security" && people.length == 0) return null;
  return (
    <div className="px-1 py-1" key={type + person.name}>
      <MenuItem>
        {({ active }: any) => (
          <div
            className={`${
              active ? "bg-main-orange text-white" : "text-gray-900"
            } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
            onClick={() => {
              if (new Date().getTime() - time < 500) return;
              setTime(new Date().getTime());
              addIncome(newIncome(type as IncomeType, person));
            }}
          >
            {title}
          </div>
        )}
      </MenuItem>
    </div>
  );
};

const AddIncome = ({ addIncome, incomes }: AddIncomeProps) => {
  const { data } = useInfo();
  const people = data.people;

  return (
    <Menu as="div" className="">
      <MenuButton className="px-4 py-3 relative inline-block text-left rounded-md font-semibold text-[16px] cursor-pointer bg-main-orange text-white">
        <div className="flex items-center gap-2 ">
          <PlusIcon className="w-5" />
          <div>Add income</div>
        </div>
      </MenuButton>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-[10px] mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none z-50 cursor-pointer">
          {[
            "employment-income",
            "social-security",
            "company-pension",
            "annuity",
            "other-income",
            "paydown",
            "investment-income",
          ]
            .map((type) =>
              type == "social-security" && people.length == 2
                ? [
                    !incomes?.find(
                      (item) =>
                        item.personId === 0 && item.type === "social-security",
                    ) && (
                      <AddItem
                        type={type}
                        title={
                          type
                            .split("-")
                            .map((i) => (i as any).capitalize())
                            .join(" ") + ` (${people[0].name})`
                        }
                        person={people[0]}
                        addIncome={addIncome}
                      />
                    ),

                    !incomes?.find(
                      (item) =>
                        item.personId === 1 && item.type === "social-security",
                    ) && (
                      <AddItem
                        type={type}
                        title={
                          type
                            .split("-")
                            .map((i) => (i as any).capitalize())
                            .join(" ") + ` (${people[1].name})`
                        }
                        person={people[1]}
                        addIncome={addIncome}
                      />
                    ),
                  ]
                : [
                    <AddItem
                      type={type}
                      title={
                        type == "employment-income"
                          ? "Employment"
                          : type == "investment-income"
                            ? "Investment"
                            : type
                                .split("-")
                                .map((i) => (i as any).capitalize())
                                .join(" ")
                      }
                      person={people[0]}
                      addIncome={addIncome}
                    />,
                  ],
            )
            .flat()}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
export default AddIncome;
